import log from 'loglevel';
import crc32 from 'crc-32';

/**
 * 播放器 token 计算
 *
 * @export
 * @class Token
 */
export default class Token {
  constructor() {
    this.player = null; // videoModule实例
    this.oToken = '';
    this.newToken = '';
    this.expireTime = 0;
  }

  /**
   * 根据旧调度拿来的token计算出播放token
   *
   * @returns
   * @memberof Token
   * @param originToken
   */
  create(originToken) {
    this.oToken = originToken;
    let pre = originToken.split('_')[0];
    let last = originToken.split('_')[1];

    // 短token 翻转
    let reverseToken = pre.split('').reverse().join('');
    let n = (crc32.str(reverseToken) >>> 0).toString(16).toUpperCase(); // >>>0 的原因是 crc32 库做完的数据可能会有负数的情况
    let newToken = `${n}_${last}`;
    this.newToken = newToken;
    this._define();
    return newToken;
  }

  _define() {
    if (!this.player) {
      log.error('没有播放器实例，无法挂载属性到player上');
      return;
    }

    //为videoModule实例增加属性和赋值
    let originToken = this.oToken;
    let newToken = this.newToken;
    const properties = {
      originToken,
      newToken,
    };
    for (const key in properties) {
      Object.defineProperty(this.player, key, {
        configurable: true,
        get: function () {
          return properties[key];
        },
        set: function (newValue) {
          properties[key] = newValue;
        }
      });
    }
  }
}
